import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { ToastService } from '../../../services/toast.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../../../services/auth.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss',
    standalone: false,
  host: {
    class: 'row flex-grow-1'
  }
})
export class LoginComponent {
	constructor(
		private route: ActivatedRoute,
		private router: Router,
        private toastService: ToastService,
        private spinner: NgxSpinnerService,
        private authService: AuthService
	) {}

    cardForm = new FormGroup({
        userName: new FormControl('', Validators.required),
        password: new FormControl('', Validators.required),
    });

    showSuccessToast() {
        this.toastService.show('Successfully logged in!', { header: 'Login Success', classname: 'bg-success text-light' });
    }
    showFailureToast() {
        this.toastService.show('Failed to log in!', { header: 'Login Failed', classname: 'bg-danger text-light' });
    }

    async submit() {
        this.spinner.show();

        const body = JSON.stringify({
            email: this.cardForm.value.userName,
            password: this.cardForm.value.password
        });

        await fetch(`${environment.authUrl}/auth/login`, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body,
        }).then(data => {
            if (data.ok) {
                this.showSuccessToast();
                this.cardForm.reset();
            } else {
                this.showFailureToast();
                throw new Error('Network request failed ' + data.statusText);
            }
            return data.json();
        }).then(responseJson => {
            this.authService.setToken(responseJson.accessToken);
            this.authService.setRefreshToken(responseJson.refreshToken);
            const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
            this.router.navigateByUrl(returnUrl);
        }).catch(error => {
            console.error('There was a problem with the fetch operation:', error);
        }).finally(() => {
            this.spinner.hide();
        });
    }
}
